import { IGenericSearchFormattedAsset } from '@mais-retorno-front/core-business/useCases/search-asset/interface';
import { createContext, ReactNode, useEffect, useState } from 'react';

interface IGeneralSearchProviderProps {
  children: ReactNode;
  values: string[];
  onAdd: (
    currentList: IGenericSearchFormattedAsset[],
    newAsset: IGenericSearchFormattedAsset
  ) => void;
  onRemove: (
    currentList: IGenericSearchFormattedAsset[],
    removedAsset: IGenericSearchFormattedAsset
  ) => void;
}

interface IGeneralSearchContextData {
  assets: IGenericSearchFormattedAsset[];
  addNewAsset(asset: IGenericSearchFormattedAsset): void;
  removeAsset(asset: IGenericSearchFormattedAsset): void;
}

export const GeneralSearchContext = createContext(
  {} as IGeneralSearchContextData
);

export const GeneralSearchProvider = ({
  children,
  values,
  onAdd,
  onRemove,
}: IGeneralSearchProviderProps) => {
  const [assets, setAssets] = useState<IGenericSearchFormattedAsset[]>([]);

  useEffect(() => {
    const formattedValues: IGenericSearchFormattedAsset[] = values.map(
      (value) => ({
        cnpj: null,
        identifier: value,
        nicename: '',
        slug: value,
        type: '',
        url: '',
        info: null,
      })
    );

    setAssets(formattedValues);
  }, [values]);

  const addNewAsset = (asset: IGenericSearchFormattedAsset) => {
    setAssets((prevState) => {
      const newValues = [...prevState, asset];

      onAdd(newValues, asset);

      return newValues;
    });
  };

  const removeAsset = (asset: IGenericSearchFormattedAsset) => {
    setAssets((prevState) => {
      const newValues = prevState.filter(
        (item) => item.identifier !== asset.identifier
      );

      onRemove(newValues, asset);

      return newValues;
    });
  };

  return (
    <GeneralSearchContext.Provider
      value={{
        assets,
        addNewAsset,
        removeAsset,
      }}
    >
      {children}
    </GeneralSearchContext.Provider>
  );
};
